module.exports = {"name":"istanbul","comment":"HF targeted for October 2019 following the Constantinople/Petersburg HF","eip":{"url":"https://eips.ethereum.org/EIPS/eip-1679","status":"Draft"},"gasConfig":{},"gasPrices":{},"vm":{},"pow":{},"casper":{},"sharding":{}}


//////////////////
// WEBPACK FOOTER
// ./~/ethereumjs-common/dist/hardforks/istanbul.json
// module id = 1069
// module chunks = 0 1 2